/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_State_CompletedInputs */



/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Player_State_CompletedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const player_state_completed = /** @type {((inputs?: Player_State_CompletedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_State_CompletedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Completado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Concluído")
	if (locale === "it") return /** @type {LocalizedString} */ ("Completato")
	return /** @type {LocalizedString} */ ("Completed")
});